import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
//import { GOOGLE_API_KEY } from '../../../services/constants';
import { map } from 'rxjs/operators';
import { environment } from './../../environments/environment';

@Injectable()
export class GeocodeService {
  GOOGLE_API_KEY = environment.googleApiKey;
  constructor(private http: HttpClient) {}

  public formatAddress(results:any) {
    console.log("format address is===",results)
    return {
      zip: this.extract(results, 'postal_code'),
      country: this.extract(results, 'country'),
      state: this.extract(results, 'administrative_area_level_1'),
      city:
        this.extract(results, 'locality') ||
        this.extract(results, 'administrative_area_level_2'),
      area:
        this.extract(results, 'sublocality') ||
        this.extract(results, 'sublocality_level_1') ||
        this.extract(results, 'sublocality_level_2'),
      address: this.extractAddress(results),
      district:
      this.extract(results, 'administrative_area_level_3')||this.extract(results, 'political')
    };
  }

  private extract(results:any, attr = 'postal_code') {
    const result = Array.isArray(results)
      ? results.find(result => result.types.includes(attr))
      : results;
    if (!result) return '';
    return (
      result.address_components.find((comp :any)=> comp.types.includes(attr)) || {
        long_name: '',
      }
    ).long_name;
  }

  private extractAddress(results:any) {
    let removeTypes = [
      'country',
      'administrative_area_level_1',
      'administrative_area_level_2',
      'administrative_area_level_3',
      'locality',
      'sublocality',
      'postal_code',
    ];
    const result = Array.isArray(results)
      ? results.find(
          result => !removeTypes.some(resultType => result.types.includes(resultType))
        )
      : results;
    if (!result) return '';
    const filteredComponents = result.address_components.filter(
      (component:any) => !removeTypes.some((resultType:any) => component.types.includes(resultType))
    );
    if (!filteredComponents || filteredComponents.length == 0) return '';
    return filteredComponents.map((component:any) => component.long_name).join(', ');
  }

  public geocode(lat:any, lng:any) {
    return this.http
      .get(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${this.GOOGLE_API_KEY}`
      )
      .pipe(map((response: any) => this.formatAddress(response.results)));
  }
   public geoZipcode(zipcode:any) {
    return this.http
      .get(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${zipcode}&key=${this.GOOGLE_API_KEY}`
      )
  }


  public distancematrix(passData:any) {
    return this.http.get(
      `https://maps.googleapis.com/maps/api/distancematrix/json?units=imperial&origins=${
        passData.longitude
      },${passData.latitude}&destinations=${passData.dropLong},${
        passData.dropLat
      }&key=${this.GOOGLE_API_KEY}`
    );
  }
}
